import _ from 'underscore';
import Lazy from 'jquery-lazy';

export default function InitLazyLoad($DOM, classes) {
  const $container = $('[data-src]');

  if( !$container.length ) {
      return false;
  }

  var throttled = _.throttle(lazyLoad, 100);

  $DOM.win.scroll(throttled);

  $DOM.win.load(function() {
    setTimeout(function() {
      $container.Lazy({
         effect: 'fadeIn',
         effectTime: 400
      });
    }, 400);
  });

  function lazyLoad() {
    $('iframe.lazyload').each(function() {
      var frame = $(this),
          vidSource  = $(frame).attr('data-src'),
          distance   = $(frame).offset().top - $(window).scrollTop(),
          distTopBot = window.innerHeight - distance,
          distBotTop = distance + $(frame).height();

      if (distTopBot >= 0 && distBotTop >= 0) { // if frame is partly in view
        $(frame).attr('src', vidSource);
        $(frame).removeAttr('data-src');
      }
    });
  }
}